import Extent from '@arcgis/core/geometry/Extent.js';
import SpatialReference from '@arcgis/core/geometry/SpatialReference.js';
import JumpExtentWidget from './JumpExtentWidget';

const FullExtentWidget = ({ view }) => {
    const targetExtent = new Extent({
        xmin: -14150703.25072198,
        ymin: 1724460.655959669,
        xmax: -7075872.59319234,
        ymax: 6815350.164313462,
        spatialReference: new SpatialReference({ wkid: 3857 })
    });

    return <JumpExtentWidget id={'fullExtentLink'} view={view} label={'Jump to Full Extent'} extent={targetExtent} />;
};

export default FullExtentWidget;
